import { useMemo } from 'react';
import { EntityChip, Icons, TableColumn, Toggle } from '@silverfort/sf-components';
import { Exclusion } from '../../../../api/types/Exclusions';

const useGetColumns = (updateExclusion: (id: string, exclusion: Partial<Exclusion>) => void) => {
    return useMemo<TableColumn<Exclusion>[]>(
        () => [
            {
                columnKey: 'is_active',
                title: '',
                render: (row) => (
                    <Toggle
                        checked={row.is_active}
                        className="w-6 h-4 mt-2"
                        onChange={(checked) => {
                            updateExclusion(row.id, { is_active: checked, id: row.id });
                        }}
                    />
                ),
                columnClassName: '!min-w-10 !max-w-10 !w-10'
            },
            {
                columnKey: 'name',
                title: 'Name'
            },
            {
                columnKey: 'excluded_guids',
                title: 'Scope',
                render: (row) => (
                    <EntityChip text={`${row.excluded_guids?.length ?? 0} Selected`} icon={Icons.Entities} />
                ),
                columnClassName: '!w-12'
            }
        ],
        [updateExclusion]
    );
};

export default useGetColumns;
